/* eslint-disable @typescript-eslint/no-explicit-any */
import { useCallback } from 'react'
import { DocumentRowValue } from '@/types/documents'
import { useDocumentRowsContext } from './providers/DocumentRowsProvider'
import { useDocumentRowValuesContext } from './providers/DocumentRowValuesProvider'

const defaultData = { value: '', refId: null, jsonValue: null }

export const getRowValuesMainValues = (documentRowValue?: DocumentRowValue) => {
  if (!documentRowValue) {
    return defaultData
  }

  if (documentRowValue.final_value !== null) {
    return {
      value: documentRowValue.final_value,
      refId: documentRowValue.final_ref_id,
      jsonValue: documentRowValue.final_value_json,
    }
  }
  if (documentRowValue.rule_value !== null) {
    return {
      value: documentRowValue.rule_value,
      refId: documentRowValue.rule_ref_id,
      jsonValue: documentRowValue.rule_value_json,
    }
  }
  if (documentRowValue.original_value !== null) {
    return {
      value: documentRowValue.original_value,
      refId: documentRowValue.original_ref_id,
      jsonValue: documentRowValue.original_value_json,
    }
  }
  return defaultData
}

type ValueData = ReturnType<typeof getRowValuesMainValues> & {
  dataLineageValues: {
    original_value?: DocumentRowValue['original_value']
    rule_value?: DocumentRowValue['rule_value']
    manual_value?: DocumentRowValue['manual_value']
    final_value?: DocumentRowValue['final_value']
  }
  metadata?: DocumentRowValue['metadata']
  origin_name?: DocumentRowValue['origin_name']
  origin_type_id?: DocumentRowValue['origin_type_id']
  ai_page_numbers?: DocumentRowValue['ai_page_numbers']
}

export default function useGetValueData() {
  const { baseRow } = useDocumentRowsContext()
  const { getFieldDocumentRowValue } = useDocumentRowValuesContext()

  const getValueData = useCallback(
    ({ fieldId, rowId }: { fieldId?: string; rowId?: string }): ValueData => {
      if (!fieldId) return {} as ValueData
      const documentRowValue = getFieldDocumentRowValue(
        fieldId,
        rowId || baseRow?.id || null,
      )
      const {
        original_value,
        rule_value,
        manual_value,
        final_value,
        metadata,
        origin_name,
        origin_type_id,
        ai_page_numbers,
      } = documentRowValue || {}

      const mainValues = getRowValuesMainValues(documentRowValue)
      return {
        ...mainValues,
        dataLineageValues: {
          original_value,
          rule_value,
          manual_value,
          final_value,
        },
        metadata,
        origin_name,
        origin_type_id,
        ai_page_numbers,
      }
    },
    [baseRow?.id, getFieldDocumentRowValue],
  )

  return getValueData
}
